export const environment = {
  production: true,
  API_URL: 'https://binblitz-api.test.jobatory.com/api',
  API_DOMAIN: 'binblitz-api.test.jobatory.com',
  CLIENT_FRONT_URL: 'https://customer.test.binblitz.net',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAIVrTRnr2wn5LAPXBiaovjT5VChqgUaH0',
  JIRA_WIDGET_DATA_KEY: '8ef68994-64b6-4900-9e32-d2ce4c1c61c8',
};
